import { useLang } from 'hooks/lang';

import { Column, Row, Collapse, LabeledInput, LabeledSelect } from 'components/Blocks';

import { OtherAdvise } from './OtherAdvise';

import { sortByProperty } from 'utils/array';
import { OTHER, issueTypes } from '../utils';
import { OTHER_CHAR_LIMIT } from './utils';

import { StateProps } from './types';

export function IssueType({ state, dispatch }: StateProps) {
  const { t } = useLang();

  return (
    <Column>
      <Row className="small_tablet:flex-col">
        <LabeledSelect
          fullWidth
          id="type"
          label={t('type')}
          onChangeDirect={(type) => dispatch({ type, subType: '', other: null })}
          value={state.type}
          options={sortByProperty(
            Object.keys(issueTypes).map((name) => ({ id: name, label: t(name) })),
            'label',
          )}
        />

        <LabeledSelect
          fullWidth
          id="subType"
          label={t('sub-type')}
          onChangeDirect={(subType) => dispatch({ subType, other: subType === OTHER ? '' : null })}
          value={state.subType}
          disabled={!state.type}
          options={
            state.type
              ? sortByProperty(
                  issueTypes[state.type as keyof typeof issueTypes].subTypes.map((name) => ({
                    id: name,
                    label: t(name),
                  })),
                  ['label'],
                )
              : []
          }
        />
      </Row>

      <Collapse expanded={state.other !== null} onlyRenderIfExpanded>
        <Column>
          <LabeledInput
            value={state.other ?? ''}
            onChange={({ target }) => dispatch({ other: target.value.slice(0, OTHER_CHAR_LIMIT) })}
            name="other"
            label={t('other-description')}
          />

          {!!state?.other && <OtherAdvise other={state?.other} />}
        </Column>
      </Collapse>
    </Column>
  );
}
